// extracted by mini-css-extract-plugin
export default {"message":"Message_message__CyE6g","show":"Message_show__x+xzI"};